import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export const extractDate = (s, format) => {
  const parsed = dayjs(s, format)
  if (parsed.isValid()) {
    return {
      date: new Date(parsed),
      iso: parsed.format('YYYY-MM-DD'),
      success: true
    }
  } else {
    return {
      success: false
    }
  }
}
